import React from 'react';

const ServicesCalendarEvent = props => {
  return (
    <div
      className={`service-calendar__event-wrapper service-calendar__event-wrapper--${props.event.service.service_type}`}
    >
      {props.children}
    </div>
  );
};

export default ServicesCalendarEvent;



// WEBPACK FOOTER //
// ./src/components/services/ServicesCalendarEventWrapper.js